import { CSSProperties } from 'react';

/** Matches a hyphen plus lowercase letter when converting kebab-case CSS properties to camelCase. */
const KEBAB_CASE_SEGMENT_PATTERN = /-([a-z])/g;

const isNonEmptyString = (value: string): value is string => value.length > 0;

const toCamelCaseProperty = (property: string): string =>
  property.replace(KEBAB_CASE_SEGMENT_PATTERN, (_, char: string) => char.toUpperCase());

/**
 * MUI `sx` and React `style` expect camelCase object keys, so inline styles must be parsed before applying.
 */
export const parseInlineStyleString = (inlineStyle: string): CSSProperties =>
  inlineStyle
    .split(';')
    .map((rule: string) => rule.trim())
    .filter(isNonEmptyString)
    .reduce<CSSProperties>((styles: CSSProperties, rule: string) => {
      const separatorIndex = rule.indexOf(':');
      if (separatorIndex === -1) return styles;

      const property = rule.slice(0, separatorIndex).trim();
      const value = rule.slice(separatorIndex + 1).trim();
      if (!property || !value) return styles;

      return { ...styles, [toCamelCaseProperty(property)]: value };
    }, {});
